{
  "CHAT_LIST": {
    "LOADING": "Preluare conversații",
    "LOAD_MORE_CONVERSATIONS": "Încarcă mai multe conversații",
    "EOF": "Toate conversațiile au fost încărcate 🎉",
    "LIST": {
      "404": "Nu sunt conversații active în acest grup."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Conversații",
    "MENTION_HEADING": "Mențiuni",
    "UNATTENDED_HEADING": "Neasistat",
    "SEARCH": {
      "INPUT": "Caută persoane, conversații, răspunsuri salvate .."
    },
    "FILTER_ALL": "Toate",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Ale mele",
      "unassigned": "Neatribuit",
      "all": "Toate"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Deschide"
      },
      "resolved": {
        "TEXT": "Rezolvat"
      },
      "pending": {
        "TEXT": "În aşteptare"
      },
      "snoozed": {
        "TEXT": "Amânat"
      },
      "all": {
        "TEXT": "Toate"
      }
    },
    "VIEW_FILTER": "Vizualizare",
    "SORT_TOOLTIP_LABEL": "Sortarea conversațiilor",
    "CHAT_SORT": {
      "STATUS": "Status",
      "ORDER_BY": "Ordonat după"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "Creat",
        "OLDEST": "Creat la:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "Ultima activitate:",
        "ACTIVE": "Ultima activitate"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      },
      "unread": {
        "TEXT": "Unread Count: Highest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Mesaj imagine"
      },
      "audio": {
        "CONTENT": "Mesaj audio"
      },
      "video": {
        "CONTENT": "Mesaj video"
      },
      "file": {
        "CONTENT": "Fişier ataşat"
      },
      "location": {
        "CONTENT": "Locaţie"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "a partajat un URL"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sortarea conversației",
      "DROPDOWN_TITLE": "Sortați după",
      "ITEMS": {
        "LATEST": {
          "NAME": "Ultima activitate la",
          "LABEL": "Ultima activitate"
        },
        "CREATED_AT": {
          "NAME": "Creat la",
          "LABEL": "Creat la"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Ultimul mesaj de utilizator la",
          "LABEL": "Ultimul mesaj"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Primit prin e-mail",
    "VIEW_TWEET_IN_TWITTER": "Vezi tweet pe Twitter",
    "REPLY_TO_TWEET": "Răspunde la acest tweet",
    "LINK_TO_STORY": "Accesați povestea Instagram",
    "SENT": "Trimis cu succes",
    "READ": "Citit cu succes",
    "DELIVERED": "Livrat cu succes",
    "NO_MESSAGES": "Niciun mesaj",
    "NO_CONTENT": "Nici un conținut disponibil",
    "HIDE_QUOTED_TEXT": "Ascunde textul citat",
    "SHOW_QUOTED_TEXT": "Arată textul citat",
    "MESSAGE_READ": "Citește",
    "SENDING": "Sending",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
